package com.altmann.choresmanager.res.myiconpack

import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush.Companion.linearGradient
import androidx.compose.ui.graphics.Brush.Companion.radialGradient
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import com.altmann.choresmanager.res.MyAchievementsPack

public val MyAchievementsPack.Duration10Achievement: ImageVector
    get() {
        if (_duration10Achievement != null) {
            return _duration10Achievement!!
        }
        _duration10Achievement = Builder(name = "Duration10Achievement", defaultWidth = 238.0.dp,
                defaultHeight = 238.0.dp, viewportWidth = 238.0f, viewportHeight = 238.0f).apply {
            path(fill = SolidColor(Color(0xFF1E1E1E)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(0.0f, 0.0f)
                horizontalLineToRelative(238.0f)
                verticalLineToRelative(238.0f)
                horizontalLineToRelative(-238.0f)
                close()
            }
            group {
                path(fill = SolidColor(Color(0xFF7522C3)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(238.0f, 0.0f)
                    horizontalLineTo(0.0f)
                    verticalLineTo(238.0f)
                    horizontalLineTo(238.0f)
                    verticalLineTo(0.0f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFFA870DB), 1.0f to Color(0xFF8F2457),
                        start = Offset(119.0f,-125.2f), end = Offset(119.0f,238.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(0.0f, -125.2f)
                    curveTo(5.01f, -123.03f, 18.04f, -118.49f, 30.03f, -112.17f)
                    curveTo(42.03f, -105.84f, 59.31f, -92.9f, 71.97f, -87.23f)
                    curveTo(84.62f, -81.56f, 94.63f, -83.83f, 105.97f, -78.16f)
                    curveTo(117.3f, -72.5f, 129.96f, -58.9f, 139.97f, -53.23f)
                    curveTo(149.98f, -47.56f, 156.02f, -49.83f, 166.03f, -44.16f)
                    curveTo(176.04f, -38.5f, 188.04f, -25.56f, 200.03f, -19.23f)
                    curveTo(212.03f, -12.9f, 231.67f, -8.37f, 238.0f, -6.2f)
                    verticalLineTo(238.0f)
                    horizontalLineTo(0.0f)
                    verticalLineTo(-125.2f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFFA870DB), 1.0f to Color(0xFF8F2457),
                        start = Offset(119.0f,-59.11f), end = Offset(119.0f,238.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(0.0f, -59.11f)
                    curveTo(7.27f, -54.04f, 27.11f, -36.85f, 43.63f, -28.7f)
                    curveTo(60.16f, -20.54f, 81.98f, -17.67f, 99.17f, -10.18f)
                    curveTo(116.36f, -2.69f, 132.22f, 6.13f, 146.77f, 16.27f)
                    curveTo(161.31f, 26.41f, 171.23f, 41.17f, 186.43f, 50.65f)
                    curveTo(201.64f, 60.13f, 229.41f, 69.39f, 238.0f, 73.14f)
                    verticalLineTo(238.0f)
                    horizontalLineTo(0.0f)
                    verticalLineTo(-59.11f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFFA870DB), 1.0f to Color(0xFF8F2457),
                        start = Offset(119.0f,6.97f), end = Offset(119.0f,238.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(0.0f, 6.97f)
                    curveTo(7.27f, 12.48f, 27.11f, 31.0f, 43.63f, 40.04f)
                    curveTo(60.16f, 49.08f, 83.3f, 51.5f, 99.17f, 61.2f)
                    curveTo(115.03f, 70.9f, 122.97f, 87.21f, 138.83f, 98.24f)
                    curveTo(154.7f, 109.26f, 177.84f, 118.3f, 194.37f, 127.34f)
                    curveTo(210.89f, 136.38f, 230.73f, 148.28f, 238.0f, 152.47f)
                    verticalLineTo(238.0f)
                    horizontalLineTo(0.0f)
                    verticalLineTo(6.97f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFEFEF)), stroke = null, fillAlpha = 0.35f,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(69.0f, 148.0f)
                    arcToRelative(50.5f, 6.0f, 0.0f, true, false, 101.0f, 0.0f)
                    arcToRelative(50.5f, 6.0f, 0.0f, true, false, -101.0f, 0.0f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xD3FFFFFF), 1.0f to Color(0x00737373),
                        start = Offset(119.0f,45.5f), end = Offset(119.0f,150.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(86.0f, 43.25f)
                    lineTo(152.0f, 43.25f)
                    arcTo(12.0f, 12.0f, 0.0f, false, true, 164.0f, 55.25f)
                    lineTo(164.0f, 125.0f)
                    arcTo(12.0f, 12.0f, 0.0f, false, true, 152.0f, 137.0f)
                    lineTo(86.0f, 137.0f)
                    arcTo(12.0f, 12.0f, 0.0f, false, true, 74.0f, 125.0f)
                    lineTo(74.0f, 55.25f)
                    arcTo(12.0f, 12.0f, 0.0f, false, true, 86.0f, 43.25f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFED3AF3)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(74.0f, 55.19f)
                    curveTo(74.0f, 48.56f, 79.37f, 43.19f, 86.0f, 43.19f)
                    horizontalLineTo(152.0f)
                    curveTo(158.63f, 43.19f, 164.0f, 48.56f, 164.0f, 55.19f)
                    verticalLineTo(56.99f)
                    horizontalLineTo(74.0f)
                    verticalLineTo(55.19f)
                    close()
                }
                path(fill = radialGradient(0.0f to Color(0x00ED3AF3), 1.0f to Color(0x42000000),
                        center = Offset(119.0f,50.09f), radius = 40.42f), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(74.0f, 55.19f)
                    curveTo(74.0f, 48.56f, 79.37f, 43.19f, 86.0f, 43.19f)
                    horizontalLineTo(152.0f)
                    curveTo(158.63f, 43.19f, 164.0f, 48.56f, 164.0f, 55.19f)
                    verticalLineTo(56.99f)
                    horizontalLineTo(74.0f)
                    verticalLineTo(55.19f)
                    close()
                }
            }
            group {
                path(fill = SolidColor(Color(0xFFffffff)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(89.91f, 49.85f)
                    arcToRelative(4.11f, 4.28f, 0.0f, true, false, 8.22f, 0.0f)
                    arcToRelative(4.11f, 4.28f, 0.0f, true, false, -8.22f, 0.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(90.83f, 49.85f)
                    arcToRelative(3.2f, 3.33f, 0.0f, true, false, 6.4f, 0.0f)
                    arcToRelative(3.2f, 3.33f, 0.0f, true, false, -6.4f, 0.0f)
                    close()
                }
                path(fill = radialGradient(0.27f to Color(0xFFD9D9D9), 0.64f to Color(0xFFA6A6A6),
                        1.0f to Color(0xFF737373), center = Offset(94.03f,44.85f), radius = 7.85f),
                        stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin
                        = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(94.03f, 37.0f)
                    lineTo(94.03f, 37.0f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 96.77f, 39.74f)
                    lineTo(96.77f, 49.96f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 94.03f, 52.7f)
                    lineTo(94.03f, 52.7f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 91.28f, 49.96f)
                    lineTo(91.28f, 39.74f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 94.03f, 37.0f)
                    close()
                }
            }
            group {
                path(fill = SolidColor(Color(0xFFffffff)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(140.17f, 49.85f)
                    arcToRelative(4.11f, 4.28f, 0.0f, true, false, 8.22f, 0.0f)
                    arcToRelative(4.11f, 4.28f, 0.0f, true, false, -8.22f, 0.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(141.08f, 49.85f)
                    arcToRelative(3.2f, 3.33f, 0.0f, true, false, 6.4f, 0.0f)
                    arcToRelative(3.2f, 3.33f, 0.0f, true, false, -6.4f, 0.0f)
                    close()
                }
                path(fill = radialGradient(0.27f to Color(0xFFD9D9D9), 0.64f to Color(0xFFA6A6A6),
                        1.0f to Color(0xFF737373), center = Offset(144.28f,44.85f), radius = 7.85f),
                        stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin
                        = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(144.28f, 37.0f)
                    lineTo(144.28f, 37.0f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 147.02f, 39.74f)
                    lineTo(147.02f, 49.96f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 144.28f, 52.7f)
                    lineTo(144.28f, 52.7f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 141.54f, 49.96f)
                    lineTo(141.54f, 39.74f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 144.28f, 37.0f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF000334), 0.73f to Color(0xFFBF00AF),
                        start = Offset(146.47f,113.94f), end = Offset(162.46f,123.71f)), stroke =
                        null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(153.09f, 123.4f)
                    curveTo(153.28f, 123.08f, 153.72f, 123.08f, 153.91f, 123.4f)
                    lineTo(157.91f, 130.25f)
                    curveTo(158.1f, 130.58f, 157.87f, 131.0f, 157.5f, 131.0f)
                    horizontalLineTo(149.5f)
                    curveTo(149.13f, 131.0f, 148.9f, 130.58f, 149.09f, 130.25f)
                    lineTo(153.09f, 123.4f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF000334), 0.73f to Color(0xFFBF00AF),
                        start = Offset(146.47f,113.94f), end = Offset(162.46f,123.71f)), stroke =
                        null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(153.08f, 124.93f)
                    curveTo(153.27f, 125.26f, 153.73f, 125.26f, 153.92f, 124.93f)
                    lineTo(157.93f, 117.74f)
                    curveTo(158.12f, 117.41f, 157.89f, 117.0f, 157.52f, 117.0f)
                    horizontalLineTo(149.48f)
                    curveTo(149.11f, 117.0f, 148.88f, 117.41f, 149.07f, 117.74f)
                    lineTo(153.08f, 124.93f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xA0FFFFFF), 1.0f to Color(0x38FFFFFF),
                        start = Offset(119.0f,182.0f), end = Offset(119.0f,219.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(23.0f, 182.0f)
                    lineTo(215.0f, 182.0f)
                    arcTo(8.0f, 8.0f, 0.0f, false, true, 223.0f, 190.0f)
                    lineTo(223.0f, 211.0f)
                    arcTo(8.0f, 8.0f, 0.0f, false, true, 215.0f, 219.0f)
                    lineTo(23.0f, 219.0f)
                    arcTo(8.0f, 8.0f, 0.0f, false, true, 15.0f, 211.0f)
                    lineTo(15.0f, 190.0f)
                    arcTo(8.0f, 8.0f, 0.0f, false, true, 23.0f, 182.0f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF590052), 0.66f to Color(0xFFBF00AF),
                        start = Offset(118.5f,217.0f), end = Offset(118.5f,183.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(51.03f, 197.01f)
                    horizontalLineTo(46.05f)
                    curveTo(45.99f, 196.5f, 45.85f, 196.04f, 45.65f, 195.63f)
                    curveTo(45.44f, 195.22f, 45.17f, 194.87f, 44.83f, 194.58f)
                    curveTo(44.49f, 194.29f, 44.09f, 194.06f, 43.63f, 193.91f)
                    curveTo(43.17f, 193.75f, 42.66f, 193.67f, 42.11f, 193.67f)
                    curveTo(41.12f, 193.67f, 40.27f, 193.91f, 39.55f, 194.4f)
                    curveTo(38.84f, 194.88f, 38.29f, 195.58f, 37.91f, 196.5f)
                    curveTo(37.53f, 197.41f, 37.34f, 198.52f, 37.34f, 199.82f)
                    curveTo(37.34f, 201.17f, 37.54f, 202.3f, 37.92f, 203.22f)
                    curveTo(38.31f, 204.13f, 38.86f, 204.81f, 39.56f, 205.28f)
                    curveTo(40.27f, 205.73f, 41.11f, 205.96f, 42.08f, 205.96f)
                    curveTo(42.62f, 205.96f, 43.11f, 205.89f, 43.56f, 205.75f)
                    curveTo(44.01f, 205.62f, 44.4f, 205.41f, 44.74f, 205.15f)
                    curveTo(45.09f, 204.88f, 45.37f, 204.55f, 45.59f, 204.16f)
                    curveTo(45.81f, 203.77f, 45.97f, 203.33f, 46.05f, 202.84f)
                    lineTo(51.03f, 202.87f)
                    curveTo(50.94f, 203.77f, 50.68f, 204.66f, 50.24f, 205.54f)
                    curveTo(49.81f, 206.41f, 49.22f, 207.21f, 48.46f, 207.93f)
                    curveTo(47.7f, 208.65f, 46.78f, 209.22f, 45.7f, 209.64f)
                    curveTo(44.62f, 210.07f, 43.38f, 210.28f, 41.98f, 210.28f)
                    curveTo(40.13f, 210.28f, 38.48f, 209.87f, 37.03f, 209.07f)
                    curveTo(35.57f, 208.25f, 34.43f, 207.06f, 33.59f, 205.51f)
                    curveTo(32.74f, 203.95f, 32.32f, 202.05f, 32.32f, 199.82f)
                    curveTo(32.32f, 197.58f, 32.75f, 195.68f, 33.61f, 194.12f)
                    curveTo(34.46f, 192.56f, 35.62f, 191.38f, 37.08f, 190.57f)
                    curveTo(38.53f, 189.76f, 40.17f, 189.36f, 41.98f, 189.36f)
                    curveTo(43.21f, 189.36f, 44.35f, 189.53f, 45.4f, 189.88f)
                    curveTo(46.44f, 190.21f, 47.37f, 190.71f, 48.16f, 191.37f)
                    curveTo(48.96f, 192.02f, 49.6f, 192.82f, 50.1f, 193.76f)
                    curveTo(50.6f, 194.71f, 50.91f, 195.79f, 51.03f, 197.01f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF590052), 0.66f to Color(0xFFBF00AF),
                        start = Offset(118.5f,217.0f), end = Offset(118.5f,183.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(58.7f, 201.29f)
                    verticalLineTo(210.0f)
                    horizontalLineTo(53.84f)
                    verticalLineTo(189.64f)
                    horizontalLineTo(58.54f)
                    verticalLineTo(197.53f)
                    horizontalLineTo(58.71f)
                    curveTo(59.06f, 196.59f, 59.62f, 195.85f, 60.4f, 195.32f)
                    curveTo(61.19f, 194.79f, 62.16f, 194.53f, 63.3f, 194.53f)
                    curveTo(64.37f, 194.53f, 65.31f, 194.77f, 66.1f, 195.24f)
                    curveTo(66.9f, 195.71f, 67.51f, 196.38f, 67.95f, 197.24f)
                    curveTo(68.4f, 198.1f, 68.61f, 199.11f, 68.61f, 200.27f)
                    verticalLineTo(210.0f)
                    horizontalLineTo(63.75f)
                    verticalLineTo(201.22f)
                    curveTo(63.75f, 200.37f, 63.54f, 199.71f, 63.11f, 199.23f)
                    curveTo(62.68f, 198.75f, 62.07f, 198.52f, 61.29f, 198.52f)
                    curveTo(60.78f, 198.52f, 60.33f, 198.63f, 59.94f, 198.85f)
                    curveTo(59.55f, 199.07f, 59.25f, 199.39f, 59.03f, 199.8f)
                    curveTo(58.82f, 200.21f, 58.71f, 200.71f, 58.7f, 201.29f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF590052), 0.66f to Color(0xFFBF00AF),
                        start = Offset(118.5f,217.0f), end = Offset(118.5f,183.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(78.77f, 210.29f)
                    curveTo(77.17f, 210.29f, 75.79f, 209.96f, 74.64f, 209.3f)
                    curveTo(73.49f, 208.64f, 72.6f, 207.72f, 71.98f, 206.54f)
                    curveTo(71.36f, 205.35f, 71.06f, 203.98f, 71.06f, 202.41f)
                    curveTo(71.06f, 200.84f, 71.36f, 199.47f, 71.98f, 198.29f)
                    curveTo(72.6f, 197.1f, 73.49f, 196.18f, 74.64f, 195.52f)
                    curveTo(75.79f, 194.86f, 77.17f, 194.53f, 78.77f, 194.53f)
                    curveTo(80.38f, 194.53f, 81.75f, 194.86f, 82.9f, 195.52f)
                    curveTo(84.05f, 196.18f, 84.94f, 197.1f, 85.55f, 198.29f)
                    curveTo(86.18f, 199.47f, 86.49f, 200.84f, 86.49f, 202.41f)
                    curveTo(86.49f, 203.98f, 86.18f, 205.35f, 85.55f, 206.54f)
                    curveTo(84.94f, 207.72f, 84.05f, 208.64f, 82.9f, 209.3f)
                    curveTo(81.75f, 209.96f, 80.38f, 210.29f, 78.77f, 210.29f)
                    close()
                    moveTo(78.8f, 206.62f)
                    curveTo(79.39f, 206.62f, 79.88f, 206.44f, 80.28f, 206.08f)
                    curveTo(80.69f, 205.72f, 81.0f, 205.23f, 81.21f, 204.59f)
                    curveTo(81.43f, 203.96f, 81.54f, 203.22f, 81.54f, 202.38f)
                    curveTo(81.54f, 201.54f, 81.43f, 200.79f, 81.21f, 200.16f)
                    curveTo(81.0f, 199.52f, 80.69f, 199.02f, 80.28f, 198.66f)
                    curveTo(79.88f, 198.31f, 79.39f, 198.13f, 78.8f, 198.13f)
                    curveTo(78.2f, 198.13f, 77.69f, 198.31f, 77.27f, 198.66f)
                    curveTo(76.86f, 199.02f, 76.54f, 199.52f, 76.33f, 200.16f)
                    curveTo(76.11f, 200.79f, 76.01f, 201.54f, 76.01f, 202.38f)
                    curveTo(76.01f, 203.22f, 76.11f, 203.96f, 76.33f, 204.59f)
                    curveTo(76.54f, 205.23f, 76.86f, 205.72f, 77.27f, 206.08f)
                    curveTo(77.69f, 206.44f, 78.2f, 206.62f, 78.8f, 206.62f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF590052), 0.66f to Color(0xFFBF00AF),
                        start = Offset(118.5f,217.0f), end = Offset(118.5f,183.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(88.98f, 210.0f)
                    verticalLineTo(194.73f)
                    horizontalLineTo(93.7f)
                    verticalLineTo(197.51f)
                    horizontalLineTo(93.86f)
                    curveTo(94.14f, 196.5f, 94.59f, 195.76f, 95.22f, 195.26f)
                    curveTo(95.85f, 194.77f, 96.59f, 194.52f, 97.42f, 194.52f)
                    curveTo(97.65f, 194.52f, 97.88f, 194.54f, 98.12f, 194.57f)
                    curveTo(98.36f, 194.6f, 98.58f, 194.64f, 98.78f, 194.7f)
                    verticalLineTo(198.92f)
                    curveTo(98.55f, 198.84f, 98.25f, 198.78f, 97.87f, 198.73f)
                    curveTo(97.5f, 198.69f, 97.17f, 198.66f, 96.87f, 198.66f)
                    curveTo(96.3f, 198.66f, 95.78f, 198.79f, 95.31f, 199.05f)
                    curveTo(94.86f, 199.3f, 94.49f, 199.66f, 94.23f, 200.12f)
                    curveTo(93.97f, 200.57f, 93.84f, 201.1f, 93.84f, 201.71f)
                    verticalLineTo(210.0f)
                    horizontalLineTo(88.98f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF590052), 0.66f to Color(0xFFBF00AF),
                        start = Offset(118.5f,217.0f), end = Offset(118.5f,183.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(107.11f, 210.29f)
                    curveTo(105.51f, 210.29f, 104.13f, 209.97f, 102.97f, 209.34f)
                    curveTo(101.82f, 208.71f, 100.93f, 207.8f, 100.31f, 206.63f)
                    curveTo(99.69f, 205.45f, 99.38f, 204.05f, 99.38f, 202.42f)
                    curveTo(99.38f, 200.85f, 99.7f, 199.47f, 100.32f, 198.29f)
                    curveTo(100.94f, 197.1f, 101.82f, 196.18f, 102.95f, 195.52f)
                    curveTo(104.09f, 194.86f, 105.42f, 194.53f, 106.96f, 194.53f)
                    curveTo(108.05f, 194.53f, 109.04f, 194.7f, 109.94f, 195.04f)
                    curveTo(110.85f, 195.37f, 111.62f, 195.87f, 112.28f, 196.54f)
                    curveTo(112.94f, 197.2f, 113.45f, 198.02f, 113.81f, 198.99f)
                    curveTo(114.18f, 199.96f, 114.36f, 201.07f, 114.36f, 202.32f)
                    verticalLineTo(203.54f)
                    horizontalLineTo(101.08f)
                    verticalLineTo(200.71f)
                    horizontalLineTo(109.83f)
                    curveTo(109.83f, 200.2f, 109.71f, 199.74f, 109.47f, 199.33f)
                    curveTo(109.23f, 198.93f, 108.9f, 198.61f, 108.48f, 198.39f)
                    curveTo(108.07f, 198.15f, 107.6f, 198.04f, 107.06f, 198.04f)
                    curveTo(106.52f, 198.04f, 106.03f, 198.16f, 105.6f, 198.41f)
                    curveTo(105.17f, 198.65f, 104.83f, 198.97f, 104.57f, 199.39f)
                    curveTo(104.32f, 199.8f, 104.19f, 200.27f, 104.18f, 200.79f)
                    verticalLineTo(203.67f)
                    curveTo(104.18f, 204.29f, 104.3f, 204.84f, 104.54f, 205.31f)
                    curveTo(104.79f, 205.77f, 105.14f, 206.13f, 105.59f, 206.39f)
                    curveTo(106.04f, 206.65f, 106.58f, 206.78f, 107.2f, 206.78f)
                    curveTo(107.63f, 206.78f, 108.02f, 206.72f, 108.37f, 206.6f)
                    curveTo(108.72f, 206.48f, 109.03f, 206.3f, 109.28f, 206.07f)
                    curveTo(109.53f, 205.84f, 109.72f, 205.55f, 109.84f, 205.22f)
                    lineTo(114.31f, 205.35f)
                    curveTo(114.12f, 206.35f, 113.72f, 207.22f, 113.09f, 207.96f)
                    curveTo(112.46f, 208.7f, 111.64f, 209.27f, 110.63f, 209.68f)
                    curveTo(109.62f, 210.09f, 108.44f, 210.29f, 107.11f, 210.29f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF590052), 0.66f to Color(0xFFBF00AF),
                        start = Offset(118.5f,217.0f), end = Offset(118.5f,183.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(122.86f, 210.0f)
                    verticalLineTo(189.64f)
                    horizontalLineTo(127.78f)
                    verticalLineTo(197.81f)
                    horizontalLineTo(135.8f)
                    verticalLineTo(189.64f)
                    horizontalLineTo(140.71f)
                    verticalLineTo(210.0f)
                    horizontalLineTo(135.8f)
                    verticalLineTo(201.82f)
                    horizontalLineTo(127.78f)
                    verticalLineTo(210.0f)
                    horizontalLineTo(122.86f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF590052), 0.66f to Color(0xFFBF00AF),
                        start = Offset(118.5f,217.0f), end = Offset(118.5f,183.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(150.93f, 210.29f)
                    curveTo(149.33f, 210.29f, 147.95f, 209.96f, 146.8f, 209.3f)
                    curveTo(145.65f, 208.64f, 144.76f, 207.72f, 144.14f, 206.54f)
                    curveTo(143.52f, 205.35f, 143.22f, 203.98f, 143.22f, 202.41f)
                    curveTo(143.22f, 200.84f, 143.52f, 199.47f, 144.14f, 198.29f)
                    curveTo(144.76f, 197.1f, 145.65f, 196.18f, 146.8f, 195.52f)
                    curveTo(147.95f, 194.86f, 149.33f, 194.53f, 150.93f, 194.53f)
                    curveTo(152.54f, 194.53f, 153.91f, 194.86f, 155.06f, 195.52f)
                    curveTo(156.21f, 196.18f, 157.1f, 197.1f, 157.71f, 198.29f)
                    curveTo(158.34f, 199.47f, 158.65f, 200.84f, 158.65f, 202.41f)
                    curveTo(158.65f, 203.98f, 158.34f, 205.35f, 157.71f, 206.54f)
                    curveTo(157.1f, 207.72f, 156.21f, 208.64f, 155.06f, 209.3f)
                    curveTo(153.91f, 209.96f, 152.54f, 210.29f, 150.93f, 210.29f)
                    close()
                    moveTo(150.96f, 206.62f)
                    curveTo(151.54f, 206.62f, 152.04f, 206.44f, 152.44f, 206.08f)
                    curveTo(152.85f, 205.72f, 153.16f, 205.23f, 153.37f, 204.59f)
                    curveTo(153.59f, 203.96f, 153.7f, 203.22f, 153.7f, 202.38f)
                    curveTo(153.7f, 201.54f, 153.59f, 200.79f, 153.37f, 200.16f)
                    curveTo(153.16f, 199.52f, 152.85f, 199.02f, 152.44f, 198.66f)
                    curveTo(152.04f, 198.31f, 151.54f, 198.13f, 150.96f, 198.13f)
                    curveTo(150.36f, 198.13f, 149.85f, 198.31f, 149.43f, 198.66f)
                    curveTo(149.02f, 199.02f, 148.71f, 199.52f, 148.49f, 200.16f)
                    curveTo(148.27f, 200.79f, 148.17f, 201.54f, 148.17f, 202.38f)
                    curveTo(148.17f, 203.22f, 148.27f, 203.96f, 148.49f, 204.59f)
                    curveTo(148.71f, 205.23f, 149.02f, 205.72f, 149.43f, 206.08f)
                    curveTo(149.85f, 206.44f, 150.36f, 206.62f, 150.96f, 206.62f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF590052), 0.66f to Color(0xFFBF00AF),
                        start = Offset(118.5f,217.0f), end = Offset(118.5f,183.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(170.99f, 203.41f)
                    verticalLineTo(194.73f)
                    horizontalLineTo(175.85f)
                    verticalLineTo(210.0f)
                    horizontalLineTo(171.21f)
                    verticalLineTo(207.16f)
                    horizontalLineTo(171.05f)
                    curveTo(170.71f, 208.09f, 170.14f, 208.83f, 169.32f, 209.38f)
                    curveTo(168.51f, 209.93f, 167.54f, 210.2f, 166.39f, 210.2f)
                    curveTo(165.35f, 210.2f, 164.43f, 209.96f, 163.64f, 209.48f)
                    curveTo(162.86f, 209.01f, 162.24f, 208.34f, 161.8f, 207.48f)
                    curveTo(161.37f, 206.62f, 161.15f, 205.62f, 161.14f, 204.46f)
                    verticalLineTo(194.73f)
                    horizontalLineTo(166.0f)
                    verticalLineTo(203.51f)
                    curveTo(166.01f, 204.34f, 166.23f, 204.99f, 166.66f, 205.47f)
                    curveTo(167.09f, 205.94f, 167.68f, 206.18f, 168.42f, 206.18f)
                    curveTo(168.9f, 206.18f, 169.34f, 206.08f, 169.72f, 205.86f)
                    curveTo(170.11f, 205.65f, 170.42f, 205.33f, 170.64f, 204.92f)
                    curveTo(170.88f, 204.5f, 170.99f, 204.0f, 170.99f, 203.41f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF590052), 0.66f to Color(0xFFBF00AF),
                        start = Offset(118.5f,217.0f), end = Offset(118.5f,183.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(178.94f, 210.0f)
                    verticalLineTo(194.73f)
                    horizontalLineTo(183.66f)
                    verticalLineTo(197.51f)
                    horizontalLineTo(183.82f)
                    curveTo(184.1f, 196.5f, 184.55f, 195.76f, 185.18f, 195.26f)
                    curveTo(185.81f, 194.77f, 186.55f, 194.52f, 187.38f, 194.52f)
                    curveTo(187.61f, 194.52f, 187.84f, 194.54f, 188.08f, 194.57f)
                    curveTo(188.32f, 194.6f, 188.54f, 194.64f, 188.74f, 194.7f)
                    verticalLineTo(198.92f)
                    curveTo(188.51f, 198.84f, 188.21f, 198.78f, 187.83f, 198.73f)
                    curveTo(187.46f, 198.69f, 187.13f, 198.66f, 186.83f, 198.66f)
                    curveTo(186.26f, 198.66f, 185.74f, 198.79f, 185.27f, 199.05f)
                    curveTo(184.82f, 199.3f, 184.46f, 199.66f, 184.19f, 200.12f)
                    curveTo(183.93f, 200.57f, 183.8f, 201.1f, 183.8f, 201.71f)
                    verticalLineTo(210.0f)
                    horizontalLineTo(178.94f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF590052), 0.66f to Color(0xFFBF00AF),
                        start = Offset(118.5f,217.0f), end = Offset(118.5f,183.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(204.06f, 199.39f)
                    lineTo(199.59f, 199.51f)
                    curveTo(199.55f, 199.19f, 199.42f, 198.91f, 199.22f, 198.66f)
                    curveTo(199.01f, 198.41f, 198.74f, 198.22f, 198.41f, 198.08f)
                    curveTo(198.09f, 197.93f, 197.71f, 197.86f, 197.28f, 197.86f)
                    curveTo(196.71f, 197.86f, 196.23f, 197.97f, 195.84f, 198.2f)
                    curveTo(195.44f, 198.42f, 195.25f, 198.73f, 195.26f, 199.11f)
                    curveTo(195.25f, 199.41f, 195.37f, 199.67f, 195.62f, 199.89f)
                    curveTo(195.87f, 200.11f, 196.32f, 200.28f, 196.96f, 200.41f)
                    lineTo(199.9f, 200.97f)
                    curveTo(201.43f, 201.26f, 202.56f, 201.75f, 203.3f, 202.42f)
                    curveTo(204.05f, 203.1f, 204.43f, 203.99f, 204.44f, 205.11f)
                    curveTo(204.43f, 206.15f, 204.12f, 207.07f, 203.5f, 207.84f)
                    curveTo(202.89f, 208.62f, 202.06f, 209.22f, 201.0f, 209.65f)
                    curveTo(199.93f, 210.08f, 198.72f, 210.29f, 197.36f, 210.29f)
                    curveTo(195.18f, 210.29f, 193.46f, 209.84f, 192.2f, 208.95f)
                    curveTo(190.94f, 208.04f, 190.23f, 206.84f, 190.05f, 205.33f)
                    lineTo(194.85f, 205.21f)
                    curveTo(194.96f, 205.76f, 195.23f, 206.19f, 195.68f, 206.48f)
                    curveTo(196.12f, 206.77f, 196.69f, 206.92f, 197.38f, 206.92f)
                    curveTo(198.0f, 206.92f, 198.51f, 206.8f, 198.9f, 206.57f)
                    curveTo(199.29f, 206.34f, 199.49f, 206.03f, 199.49f, 205.65f)
                    curveTo(199.49f, 205.3f, 199.34f, 205.02f, 199.04f, 204.82f)
                    curveTo(198.74f, 204.61f, 198.27f, 204.44f, 197.63f, 204.32f)
                    lineTo(194.97f, 203.82f)
                    curveTo(193.44f, 203.54f, 192.3f, 203.02f, 191.55f, 202.27f)
                    curveTo(190.8f, 201.52f, 190.43f, 200.56f, 190.44f, 199.39f)
                    curveTo(190.43f, 198.37f, 190.7f, 197.5f, 191.25f, 196.78f)
                    curveTo(191.8f, 196.05f, 192.58f, 195.49f, 193.6f, 195.1f)
                    curveTo(194.61f, 194.72f, 195.81f, 194.53f, 197.19f, 194.53f)
                    curveTo(199.26f, 194.53f, 200.89f, 194.96f, 202.08f, 195.83f)
                    curveTo(203.27f, 196.69f, 203.93f, 197.88f, 204.06f, 199.39f)
                    close()
                }
                path(fill = linearGradient(0.34f to Color(0xFFBF00AF), 1.0f to Color(0xFF590052),
                        start = Offset(120.5f,75.0f), end = Offset(120.5f,114.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(113.48f, 82.73f)
                    verticalLineTo(106.0f)
                    horizontalLineTo(107.86f)
                    verticalLineTo(87.98f)
                    horizontalLineTo(107.73f)
                    lineTo(102.52f, 91.16f)
                    verticalLineTo(86.3f)
                    lineTo(108.26f, 82.73f)
                    horizontalLineTo(113.48f)
                    close()
                }
                path(fill = linearGradient(0.34f to Color(0xFFBF00AF), 1.0f to Color(0xFF590052),
                        start = Offset(120.5f,75.0f), end = Offset(120.5f,114.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(128.25f, 106.57f)
                    curveTo(126.22f, 106.57f, 124.47f, 106.09f, 123.0f, 105.13f)
                    curveTo(121.53f, 104.15f, 120.39f, 102.76f, 119.6f, 100.96f)
                    curveTo(118.8f, 99.14f, 118.41f, 96.95f, 118.42f, 94.4f)
                    curveTo(118.43f, 91.84f, 118.82f, 89.68f, 119.61f, 87.9f)
                    curveTo(120.41f, 86.11f, 121.54f, 84.75f, 123.0f, 83.82f)
                    curveTo(124.47f, 82.88f, 126.22f, 82.41f, 128.25f, 82.41f)
                    curveTo(130.28f, 82.41f, 132.03f, 82.88f, 133.5f, 83.82f)
                    curveTo(134.97f, 84.75f, 136.11f, 86.11f, 136.91f, 87.9f)
                    curveTo(137.7f, 89.69f, 138.1f, 91.85f, 138.09f, 94.4f)
                    curveTo(138.09f, 96.96f, 137.69f, 99.15f, 136.9f, 100.97f)
                    curveTo(136.1f, 102.78f, 134.97f, 104.17f, 133.5f, 105.14f)
                    curveTo(132.04f, 106.09f, 130.29f, 106.57f, 128.25f, 106.57f)
                    close()
                    moveTo(128.25f, 101.97f)
                    curveTo(129.46f, 101.97f, 130.44f, 101.35f, 131.19f, 100.11f)
                    curveTo(131.94f, 98.87f, 132.31f, 96.97f, 132.3f, 94.4f)
                    curveTo(132.3f, 92.72f, 132.13f, 91.33f, 131.79f, 90.24f)
                    curveTo(131.45f, 89.14f, 130.98f, 88.32f, 130.37f, 87.78f)
                    curveTo(129.77f, 87.25f, 129.06f, 86.98f, 128.25f, 86.98f)
                    curveTo(127.04f, 86.98f, 126.07f, 87.59f, 125.33f, 88.81f)
                    curveTo(124.58f, 90.02f, 124.21f, 91.88f, 124.2f, 94.4f)
                    curveTo(124.19f, 96.1f, 124.36f, 97.52f, 124.69f, 98.64f)
                    curveTo(125.03f, 99.76f, 125.51f, 100.6f, 126.12f, 101.15f)
                    curveTo(126.74f, 101.69f, 127.44f, 101.97f, 128.25f, 101.97f)
                    close()
                }
            }
        }
        .build()
        return _duration10Achievement!!
    }

private var _duration10Achievement: ImageVector? = null
